import Vue from 'vue';
import VueCustomElement from 'vue-custom-element';
import { CouponExit, CouponSlider } from 'common';
import { vueCustomElementOptions } from 'static-components/src/vue-customelement-options';
var initializeCouponElements = function () {
    var isMobile = (768 > (window.innerWidth || document.documentElement.clientWidth));
    if (!isMobile) {
        Vue.use(VueCustomElement);
        Vue.customElement('c-coupon-slider', (new CouponSlider().$options), vueCustomElementOptions);
        Vue.customElement('c-coupon-exit', (new CouponExit().$options), vueCustomElementOptions);
    }
};
export default initializeCouponElements;
